import { render } from "./ViewStudentClassRecordDialog.vue?vue&type=template&id=0bce8209&scoped=true"
import script from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"
export * from "./ViewStudentClassRecordDialog.vue?vue&type=script&lang=js"

import "./ViewStudentClassRecordDialog.vue?vue&type=style&index=0&id=0bce8209&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce8209"]])

export default __exports__